import {inject, Injectable} from "@angular/core";
import {ModalController} from "@ionic/angular/standalone";
import {OnboardingSheetsService} from "@services/api";
import {firstValueFrom} from "rxjs";
import {OnboardingSheet} from "@app/interfaces";
import {SettingsRepository} from "@app/repositories/settings.repository";

@Injectable({
  providedIn: 'root'
})
export class OnboardingSheetService {
  private modal: HTMLIonModalElement | undefined;
  private sheets: OnboardingSheet[] = [];

  private settingsRepository: SettingsRepository = inject(SettingsRepository);
  private onboardingSheetService: OnboardingSheetsService = inject(OnboardingSheetsService);
  private modalController: ModalController = inject(ModalController);

  constructor() {
    this.settingsRepository.settings$.subscribe(async (settings) => {
      if (settings.hasSeenOnboarding) {
        return;
      }

      const sheets = await firstValueFrom(this.onboardingSheetService.fetch());
      if (sheets && sheets.length > 0) {
        this.sheets = sheets;
      }
    });
  }

  async maybeShowOnboarding() {
    if (this.sheets.length > 0) {
      await this.open(this.sheets);
    }
  }

  async open(sheets: OnboardingSheet[]) {
    console.log(`${this.constructor.name}.open`);
    if (this.modal) {
      return;
    }

    const {OnboardingSheetComponent} = await import('@app/components/user/onboarding-sheet/onboarding-sheet.component');

    this.modal = await this.modalController.create({
      component: OnboardingSheetComponent,
      componentProps: {sheets},
      backdropDismiss: false,
      cssClass: 'auto-height',
    });

    this.modal.addEventListener('close-onboarding-sheet', () => this.close());

    await this.modal.present();
  }

  async close() {
    this.settingsRepository.setHasSeenOnboarding();
    console.log(`${this.constructor.name}.close`, this.modal);
    await this.modal?.dismiss();
  }
}
